const SPLITTER = '-' as const;

type SP = typeof SPLITTER;

export type UUUIDVersion = 1 | 2 | 3 | 4 | 5;

export type UUID<Ver extends UUUIDVersion = 5> = Ver extends 1
  ? string & { _uuidV1: true }
  : Ver extends 2
  ? `${string}${SP}${string}` & { _uuidV2: true }
  : Ver extends 3
  ? `${string}${SP}${string}${SP}${string}` & { _uuidV3: true }
  : Ver extends 4
  ? `${string}${SP}${string}${SP}${string}${SP}${string}` & { _uuidV4: true }
  : Ver extends 5
  ? `${string}${SP}${string}${SP}${string}${SP}${string}${SP}${string}` & { _uuidV5: true }
  : never;

export const uuid = <Ver extends UUUIDVersion = 5>(ver = 5 as Ver) => {
  if (ver > 5 || ver < 1) {
    throw new Error('Version range is not supported');
  }

  const id = crypto.randomUUID();

  return id.split(SPLITTER).slice(0, ver).join(SPLITTER) as UUID<Ver>;
};
